export default "__VITE_ASSET__ZYTZiMEc__"